import { apiClient } from "../client";
const ENDPOINTS = {
    LIST: "/documents",
    BY_CONTACT: "/documents/contact",
    BY_JOB: "/documents/job",
    UPLOAD: "/documents/upload",
};
export const documentsService = {
    // Get all documents with filters
    getDocuments: (filters) => {
        const params = new URLSearchParams();
        if (filters?.contactId)
            params.append("contactId", filters.contactId);
        if (filters?.category && filters.category !== "all")
            params.append("category", filters.category);
        if (filters?.search)
            params.append("search", filters.search);
        if (filters?.sortBy)
            params.append("sortBy", filters.sortBy);
        if (filters?.sortOrder)
            params.append("sortOrder", filters.sortOrder);
        if (filters?.page)
            params.append("page", filters.page.toString());
        if (filters?.pageSize)
            params.append("pageSize", filters.pageSize.toString());
        return apiClient.get(`${ENDPOINTS.LIST}?${params.toString()}`);
    },
    // Get documents for a specific contact
    getDocumentsByContact: (contactId, category) => {
        const params = new URLSearchParams();
        if (category && category !== "all")
            params.append("category", category);
        return apiClient.get(`${ENDPOINTS.BY_CONTACT}/${contactId}?${params.toString()}`);
    },
    // Get document counts by category for a contact
    getDocumentCountsByContact: (contactId) => apiClient.get(`${ENDPOINTS.BY_CONTACT}/${contactId}/counts`),
    // Get documents for a specific site
    getDocumentsBySite: (siteId, siteCategory) => {
        const params = new URLSearchParams();
        if (siteCategory && siteCategory !== "all")
            params.append("siteCategory", siteCategory);
        return apiClient.get(`/documents/site/${siteId}?${params.toString()}`);
    },
    // Get document counts by category for a site
    getDocumentCountsBySite: (siteId) => apiClient.get(`/documents/site/${siteId}/counts`),
    // Get documents for a specific quote (e.g. when estimate has no linked site)
    getDocumentsByQuote: (quoteId) => apiClient.get(`/documents/quote/${quoteId}`),
    // Get documents for a specific job (documents uploaded via /documents/upload with jobId).
    // Optional jobCategory filter (query param jobCategory, not category); comparison is case-insensitive on backend.
    getDocumentsByJob: (jobId, jobCategory) => {
        const params = new URLSearchParams();
        if (jobCategory != null && String(jobCategory).trim() !== "")
            params.append("jobCategory", String(jobCategory).trim());
        const query = params.toString();
        return apiClient.get(`${ENDPOINTS.BY_JOB}/${jobId}${query ? `?${query}` : ""}`);
    },
    // Get single document
    getDocument: (id) => apiClient.get(`${ENDPOINTS.LIST}/${id}`),
    // Get download URL
    getDownloadUrl: (id) => apiClient.get(`${ENDPOINTS.LIST}/${id}/download`),
    // Upload document
    uploadDocument: (file, dto) => {
        const formData = new FormData();
        formData.append("file", file);
        if (dto.contactId)
            formData.append("contactId", dto.contactId);
        if (dto.siteId)
            formData.append("siteId", dto.siteId);
        if (dto.name)
            formData.append("name", dto.name);
        if (dto.category)
            formData.append("category", dto.category);
        if (dto.siteCategory)
            formData.append("siteCategory", dto.siteCategory);
        if (dto.description)
            formData.append("description", dto.description);
        return apiClient.post(ENDPOINTS.UPLOAD, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
    },
    // Upload job document (form: file, jobId, name, jobCategory, optional description)
    uploadJobDocument: (file, dto) => {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("jobId", dto.jobId);
        formData.append("name", dto.name);
        formData.append("jobCategory", dto.jobCategory);
        if (dto.description)
            formData.append("description", dto.description);
        return apiClient.post(ENDPOINTS.UPLOAD, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
    },
    // Upload quote document (form: file, quoteId, name, quoteCategory)
    uploadQuoteDocument: (file, dto) => {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("quoteId", dto.quoteId);
        formData.append("name", dto.name);
        formData.append("quoteCategory", dto.quoteCategory);
        return apiClient.post(ENDPOINTS.UPLOAD, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
    },
    // Update document
    updateDocument: (id, data) => apiClient.put(`${ENDPOINTS.LIST}/${id}`, data),
    // Delete document
    deleteDocument: (id) => apiClient.delete(`${ENDPOINTS.LIST}/${id}`),
};
